import axios from '../../axios'

/*
 * 实体成员数据接口
 */
// 获取实体成员列表
export const getEmployeeList = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/employee/page',
        method: 'get',
        data
    })
}

// 实体成员id查询
export const getEmployeeId = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/employee/get',
        method: 'get',
        data
    })
}

// 新增实体成员信息
export const addEmployee = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/employee',
        method: 'post',
        data
    })
}

// 编辑实体成员信息
export const updateEmployee = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/employee',
        method: 'put',
        data
    })
}

// 删除实体成员列表
export const deleteEmployee = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/employee',
        method: 'delete',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/tiktok/employee.js